import { render } from "./ListRequestRibPage.vue?vue&type=template&id=7d514004&ts=true"
import script from "./ListRequestRibPage.vue?vue&type=script&lang=ts"
export * from "./ListRequestRibPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__